import { SELECIONAR_MANUTENCAO_VEICULO } from '../types'

export default function selecionaManutencaoVeiculo (manutencaoVeiculo) {
  return {
    type: SELECIONAR_MANUTENCAO_VEICULO,
    payload: manutencaoVeiculo
  }
}